module.exports = __webpack_public_path__ + "static/media/moduleManager.0f0a4897.svg";